export default __webpack_public_path__ + "static/MergeIT-Logo-633364079c9cdfd52781b5a2c2d09838.png";